<template>
  <v-container id="lock" class="fill-height" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <v-card class="mt-6 mt-md-0" light max-width="100%" width="250">
          <v-card-text class="text-center">
            <v-avatar class="mt-n12 mb-6 elevation-12" color="grey" size="88">
              <v-img :src="image" />
            </v-avatar>

            <div
              class="display-2 font-weight-light mb-3 text--darken-2 grey--text"
            >
              {{ name }}
            </div>

            <v-text-field
              v-model="password"
              type="password"
              class="mb-8"
              color="secondary"
              :label="$t('password')"
            />

            <pages-btn v-on:click="doLogin">{{ $t("unlock") }}</pages-btn>
            <p slot="error" class="text-danger">{{ message }}</p>
          </v-card-text>
        </v-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PagesLock",

  components: {
    PagesBtn: () => import("./components/Btn"),
  },
  created() {
    localStorage.setItem("authToken", "");
  },
  data() {
    return {
      password: null,
      email: window.myData.email,
      message: "",
      name: window.myData.user,
      image: window.myData.avatar,
    };
  },
  methods: {
    doLogin: function (event) {
      let _ = this;
      this.chiamataAxios("POST", "/public/portal/login", {
        body: {
          type: "local",
          username: _.email,
          password: _.password,
        },
        unauthLoginRedirect: false,
      }).then((response) => {
        localStorage.setItem("authToken", response.data.token);
        _.$router.push("/portal");
      });
    },
  },
};
</script>
